import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  codelistData: {},
  rawCodeListData: [],
  codeListStringArray: {},
  codeListObjData: {}
};

const removeDuplicates = (arr: any) => {
  return arr.filter((item: any, index: number) => arr.indexOf(item) === index);
};

const getConfigList = (arr: any) => {
  const data = arr.map((ele: any) => ele.code_list_code);
  return removeDuplicates(data);
};

const getCodeListObjData = (code_list: any, config_list: any) => {
  const temp: any = {};
  for (const code of config_list) {
    temp[code] = code_list
      .filter((item: any) => item.code_list_code === code)
      .map((item: any) => {
        return {
          code: item.code_list_code,
          key: item.submission_value,
          displayName: item.synonym || item.submission_value
        };
      });
  }
  return temp;
};
const getCodeListStringArray = (code_list: any, config_list: any) => {
  const temp: any = {};
  for (const code of config_list) {
    temp[code] = code_list
      .filter((item: any) => item.code_list_code === code)
      .map((item: any) => item.submission_value);
  }
  return temp;
};
const getCodelistData = (code_list: any, config_list: any) => {
  const temp: any = {};
  for (const code of config_list) {
    temp[code] = code_list
      .filter((item: any) => item.code_list_code === code)
      .map((item: any) => {
        return item;
      });
  }
  return temp;
};
export const codelistData = createSlice({
  name: 'codelistData',
  initialState,
  reducers: {
    setCodelistData: (state, action: PayloadAction<any>) => {
      const configList = getConfigList(action.payload) || [];
      state.codelistData = getCodelistData(action.payload, configList);
      state.rawCodeListData = action.payload;
      state.codeListStringArray = getCodeListStringArray(action.payload, configList);
      state.codeListObjData = getCodeListObjData(action.payload, configList);
    }
  }
});

export const { setCodelistData } = codelistData.actions;
